import * as React from "react";
import { withTrans } from "../i18n/withTrans";

import { pageTexts } from "../content/sweatshirt";
import { associates } from "../content/pages/associatesSecondary";

// components
import Layout from "../components/layout";
import CenteredPage from "../components/_page/centeredPage";

class sweatshirtPage extends React.Component {
  constructor(props) {
    super(props);
    this.t = props.t;
    this.content = pageTexts(this.t);
    this.associates = associates(this.t);
  }

  render() {
    return (
      <Layout pageName="sweatshirt" whiteMenu={false}>
        <CenteredPage content={this.content} associates={this.associates}></CenteredPage>
      </Layout>
    );
  }
}

export default withTrans(sweatshirtPage);
